import { Link, useLocation } from "react-router-dom";
import { useStore } from "src/stores/Store";
import { StripeType } from "types/code-generator";

export function AdyenActionBanner() {
  const store = useStore();
  const location = useLocation();
  const isBankPage = location.pathname === "/admin/bank";
  const showAdyenBanner =
    store.organization.paymentDisplay === StripeType.Adyen &&
    store.organization.stripe !== StripeType.Adyen &&
    store.organization.balanceAccounts.length === 0;

  if (!showAdyenBanner) {
    return null;
  }

  return (
    <Link
      to="/admin/bank"
      className="mb-4 block rounded-lg bg-paleMain px-6 py-4 pb-2 text-dark"
    >
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-main">
          <i className="far fa-triangle-exclamation text-xl text-white" />
        </div>
        <div className="flex-1 font-bold">
          {!isBankPage && "Exciting Updates! "}Action required by November 30
        </div>
      </div>

      <p>
        In our commitment to growth and enhancements, Captyn is moving to a new
        payments system, powered by Adyen!
      </p>

      {isBankPage && (
        <p>
          This required transition is seamless and easy; we simply need you to
          take one step. Just click <strong>+ Add a bank</strong> at the top of
          this screen.
        </p>
      )}

      {!isBankPage && (
        <p>
          This required transition is seamless and easy; we simply need you to
          take one step. Just{" "}
          <span className="text-organization">click this link</span> and choose
          + Add a bank.
        </p>
      )}

      <p>
        <strong>We need you to complete this step by November 30th.</strong>
      </p>
    </Link>
  );
}
